import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

type ProductCardContext = 'order' | 'edit'

const BORDER_RADIUS_BY_CONTEXT: Record<ProductCardContext, number> = {
  order: 12,
  edit: 16,
}

export const ProductCardContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'context',
})<{ context: ProductCardContext }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  border: 1px solid ${COLORS.borderDefault};
  border-radius: ${({ context }) => BORDER_RADIUS_BY_CONTEXT[context]}px;
  background-color: ${COLORS.bgWhite};
`

export const ProductRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const ProductImage = styled.img`
  flex-shrink: 0;
  width: 63px;
  height: 63px;
`

export const ProductMeta = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const ProductName = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: ${COLORS.textPrimary};
`

export const ProductPrice = styled.p`
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  color: ${COLORS.textDisabled};
`

export const ProductStepperRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`
